// Firebase client initialization for A Homely Abode.
// Exposes the singletons used across the app (auth, db, storage, functions).
// Auto-connects to local emulators when running on localhost or when
// REACT_APP_USE_EMULATORS === "true".

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const FUNCTIONS_REGION =
  process.env.REACT_APP_FUNCTIONS_REGION || "asia-southeast1";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);

// --- Emulator wiring (dev only) ----------------------------------------
const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const USING_EMULATORS =
  process.env.REACT_APP_USE_EMULATORS === "true" || isLocalhost;

if (USING_EMULATORS) {
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    connectStorageEmulator(storage, "127.0.0.1", 9199);
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    // eslint-disable-next-line no-console
    console.info("[firebase] Connected to local emulators");
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[firebase] Emulator connect skipped:", err?.message);
  }
}
